module.exports = __webpack_public_path__ + "img/Metastasis-PRCA_10X_ANS.70825068.png";